import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';
import { MobileHeaderComponent } from './components/mobile-header/mobile-header.component';
import { TopbarComponent } from './components/topbar/topbar.component';
import { StickyMenuComponent } from './components/sticky-menu/sticky-menu.component';



@NgModule({
  declarations: [
    TopbarComponent,
    HeaderComponent,
    FooterComponent,
    MobileHeaderComponent,
    StickyMenuComponent
  ],
  imports: [
    CommonModule,
    RouterModule
  ],
  exports: [
    TopbarComponent,
    HeaderComponent,
    FooterComponent,
    MobileHeaderComponent,
    StickyMenuComponent
  ]
})
export class SharedModule { }


